import type { Collaborator } from '@/models/bootstrap/info';

export enum Permissions {
  Admin = 'Admin',
  HR = 'H.R.',
  Financial = 'Financial',
  RefundManagement = 'refund_request_manager',
  Manager = 'manager',
  PathsManager = 'paths_manager',
  EducationalManager = 'educational_manager',
}

export interface Permission {
  id: number;
  nome: Permissions;
}

export interface User {
  id: number;
  nome: string;
  email?: string;
  permissoes: Permission[];
  terms_accepted: boolean;
  colaborador: Collaborator;
}
